import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../../components/Layout/icons/index";
import Logo from "@/assets/images/logo.png";
import "./style.scss";

function chunkArray(array, chunkSize) {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }

  return result;
}
export const Sidebar = ({ menu }) => {
  return (
    <aside className={"sidebar"}>
      <div>
        <div className="sidebar-top">
          <Link to="/" className="sidebar-top__logo">
            <img src={Logo} alt="" />
          </Link>
        </div>

        <nav className="sidebar-list">
          <div>
            {menu.map((menuItem, i) => {
              const cols = menuItem.cols || 1;
              const child = chunkArray(menuItem.children || [], cols);
              const width = cols > 1 ? child.length * 250 + "px" : "250px";
              return menuItem.link ? (
                <Link
                  to={menuItem.link}
                  className={"sidebar-list__item"}
                  key={i}
                >
                  <Icon
                    icon={menuItem.icon}
                    className="sidebar-list__item-icon"
                  />
                  <span className="sidebar-list__item-label">
                    {menuItem.label}
                  </span>
                </Link>
              ) : (
                <div className="sidebar-list__item" key={i}>
                  <Icon
                    icon={menuItem.icon}
                    className="sidebar-list__item-icon"
                  />
                  <span className="sidebar-list__item-label">
                    {menuItem.label}
                  </span>
                  <div className="sidebar-list__item-child">
                    <div
                      className="sidebar-list__item-child-wrap !flex"
                      style={{ width: width }}
                    >
                      {cols > 1 ? (
                        <>
                          {child.map((childMenus, ind) => (
                            <div className="flex-1" key={ind}>
                              {childMenus.map((childItem, i) => {
                                return (
                                  <Link to={childItem.link} key={i}>
                                    <div>{childItem.label}</div>
                                  </Link>
                                );
                              })}
                            </div>
                          ))}
                        </>
                      ) : (
                        <div className="flex-1">
                          {menuItem.children.map((childItem, i) => {
                            return (
                              <Link to={childItem.link} key={i}>
                                <div>{childItem.label}</div>
                              </Link>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </nav>
      </div>
    </aside>
  );
};
